import * as React from "react";
import {cx} from "emotion";

import "./shipping-quantity.scss";

import {isAllFixedQuantity} from "@Common/logic/template-options/is-all-fixed-quantity";
import {cs}                 from "@Common/react/chain-services";
import {DebounceCache}      from "@Common/react/debounce-cache";
import {NumberInputBinding} from "@Common/react/number-input-binding";
import {Select}             from "@Common/ui-components/heavy/common/design2/select/select";
import {formatMoney1}       from "@Common/ui-components/language/format-money";
import {sort}               from "@Common/utils/collections";
import {chain}              from "@Common/utils/fs";

import {getQuantityErrorMessage} from "../../../customize/steps/common/get-quantity-error-message";
import {IsShowPricing}           from "../../check-show-pricing";
import {MoneySpan}               from "../../form/money-span/money-span";

export const ShippingQuantity = ({paperPrices, paperPrice, state, hidePricing=false, domRef, eh, showErrors}) => cs(
    ["showPricing", (_, next) => IsShowPricing({next})],
    ({showPricing}) => (
        <div className={cx("shipping-quantity-9hi", {showErrors}, eh.css)} ref={domRef}>
            <div className="line1">
                <div className="left">
                    <div className="label" xd-qa-type="label" xd-qa-name="Quantity">
                        Quantity
                    </div>
                    {!paperPrices ? (
                        <div {...{
                            className: "error",

                            "xd-qa-type": "label",
                            "xd-qa-name": "ERROR: No pricing policy",
                        }}>
                            ERROR: No pricing policy
                        </div>
                    ) : isAllFixedQuantity(paperPrices) ? cs(
                        ({}) => chain(
                            Object.keys(paperPrices).map((p) => ({price: +p, quantity: paperPrices[p].min})),
                            (_) => sort(_, (p) => p.quantity),
                            (_) => Select({
                                list: _,
                                itemToLabel: (p) => p.quantity,
                                itemToInfo: (p) => !showPricing ? null : MoneySpan({value: p.price}),
                                onChange: (p) => state.onChange(p.quantity),
                                isSelected: (p) => state.value === p.quantity,
                            })
                        )
                    ) : (
                        <div className="input">
                            {cs(
                                ["debounce", (_, next) => DebounceCache({
                                    state,
                                    next,
                                })],
                                ["binding", ({debounce}, next) => NumberInputBinding({
                                    state: debounce.state,
                                    onFlush: debounce.flush,
                                    next,
                                })],
                                ({binding}) => (
                                    <input {...{
                                        "xd-qa-type": "text_field",
                                        "xd-qa-name": "Quantity",
                                        className: cx({hasError: showErrors && !paperPrice}),
                                        ...binding,
                                    }}/>
                                )
                            )}
                            {showPricing && !hidePricing && paperPrice?.price && MoneySpan({value: paperPrice.price, xdQaName: "Price Per Piece"})}
                        </div>
                    )}
                </div>

                {showPricing && !hidePricing && (
                    <div className="right">
                        <div className="label" xd-qa-type="label" xd-qa-name="Quantity Subtotal">
                            Subtotal:
                        </div>
                        <div className="amount" xd-qa-type="label" xd-qa-name="Quantity Subtotal Amount">
                            {!state.value || !paperPrice?.price ? "--" : (
                                formatMoney1(paperPrice.price * (paperPrice.isFlatRate ? 1 : state.value))
                            )}
                        </div>
                    </div>
                )}
            </div>

            {!paperPrice && showErrors && (
                <div className="error">
                    {getQuantityErrorMessage(state.value, {paperPrices, method: "shipping"})}
                </div>
            )}
        </div>
    ),
);
